import { Box } from '@mui/material';
import {
  ResponseDataHandle,
  ListPlaceholder,
  ErrorList,
  EmptyData,
} from '@/components/common';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';
import { User } from '@/@types/user';
import { UsersTable } from '../UsersTable';
import { UsersTableColumns } from '../UsersTable/UserTableColumns';

type TUsersData = {
  users: User[];
  totalCount: number;
};

interface IUsersListProps {
  isLoading: boolean;
  isError: boolean;
  data: TUsersData | undefined;
  sort?: 'desc' | 'asc';
  sortBy?: keyof User;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function UsersList({
  isLoading,
  isError,
  data,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: IUsersListProps) {
  return (
    <ResponseDataHandle
      isLoading={isLoading}
      loadingComponent={
        <ListPlaceholder
          headers={['Nome', 'Colaborador', 'Perfil', 'Criado em', 'Ações']}
        />
      }
      isError={isError}
      errorComponent={
        <Box py={10}>
          <ErrorList text="Falha ao obter os dados dos usuários." />
        </Box>
      }
      totalItems={data?.totalCount}
      emptyComponent={
        <Box py={10}>
          <EmptyData />
        </Box>
      }
    >
      <UsersTable
        columns={UsersTableColumns}
        data={data?.users || []}
        sort={sort}
        sortBy={sortBy}
        onSort={onSort}
        actions={actions}
        pagination={pagination}
      />
    </ResponseDataHandle>
  );
}
